"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../../components/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var calculateOffset = function calculateOffset(_ref) {
  var value = _ref.value,
      max = _ref.max,
      barWidth = _ref.barWidth,
      textWidth = _ref.textWidth;
  var finalOffset = 0;
  if (!barWidth || !textWidth) return finalOffset; // how much width of the progress bar is filled, then center the text above where the bar fill ends.

  var offsetForFill = value / max * barWidth;
  var offsetForText = offsetForFill - textWidth / 2;
  var widthRightOfBar = offsetForText + textWidth - barWidth;
  var widthLeftOfBar = offsetForText < 0;
  finalOffset = widthLeftOfBar ? offsetForText + (textWidth / 2 - offsetForFill) : // when text is sticking out beyond where the bar begins to the left.
  widthRightOfBar > 0 ? offsetForText - widthRightOfBar : // when text is sticking out beyond where the bar ends to the right.
  offsetForText; // any other case.

  return finalOffset;
};

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var ProgressBar = function ProgressBar(_ref2) {
  var id = _ref2.id,
      max = _ref2.max,
      value = _ref2.value,
      minValueText = _ref2.minValueText,
      maxValueText = _ref2.maxValueText,
      progressValueText = _ref2.progressValueText,
      children = _ref2.children,
      className = _ref2.className,
      progressBarClassName = _ref2.progressBarClassName,
      textContainerClassName = _ref2.textContainerClassName,
      colour = _ref2.colour,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["id", "max", "value", "minValueText", "maxValueText", "progressValueText", "children", "className", "progressBarClassName", "textContainerClassName", "colour"]);
  var classes = useStyles({
    props: {
      colour: colour
    }
  });
  var barRef = (0, _react.useRef)(null);
  var textRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      barWidth = _useState2[0],
      setBarWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      progressValueTextWidth = _useState4[0],
      setProgressValueTextWidth = _useState4[1];

  window.addEventListener('resize', function () {
    var _barRef$current;

    if ((barRef === null || barRef === void 0 ? void 0 : (_barRef$current = barRef.current) === null || _barRef$current === void 0 ? void 0 : _barRef$current.offsetWidth) !== barWidth) {
      var _barRef$current2;

      setBarWidth(barRef === null || barRef === void 0 ? void 0 : (_barRef$current2 = barRef.current) === null || _barRef$current2 === void 0 ? void 0 : _barRef$current2.offsetWidth);
    }
  });
  (0, _react.useEffect)(function () {
    var _barRef$current3, _textRef$current;

    setBarWidth(barRef === null || barRef === void 0 ? void 0 : (_barRef$current3 = barRef.current) === null || _barRef$current3 === void 0 ? void 0 : _barRef$current3.offsetWidth);
    setProgressValueTextWidth(textRef === null || textRef === void 0 ? void 0 : (_textRef$current = textRef.current) === null || _textRef$current === void 0 ? void 0 : _textRef$current.offsetWidth);
  }, [value, max]);
  var finalOffset = calculateOffset({
    value: value,
    max: max,
    barWidth: barWidth,
    textWidth: progressValueTextWidth
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    id: id,
    className: (0, _classnames["default"])(classes.ProgressBarContainer, className),
    "data-test-id": "".concat(id, "-progress-bar")
  }, rest), progressValueText && /*#__PURE__*/_react["default"].createElement("span", {
    ref: textRef,
    "data-test-id": "".concat(id, "-progress-bar-value-text"),
    style: {
      marginLeft: "".concat(finalOffset, "px")
    }
  }, progressValueText), /*#__PURE__*/_react["default"].createElement("progress", {
    className: (0, _classnames["default"])(classes.ProgressBar, progressBarClassName),
    "data-test-id": "".concat(id, "-progress-bar-bar"),
    max: max,
    value: value,
    ref: barRef
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.TextContainer, textContainerClassName),
    "data-test-id": "".concat(id, "-progress-bar-text-container")
  }, minValueText && /*#__PURE__*/_react["default"].createElement("span", {
    "data-test-id": "".concat(id, "-progress-bar-min-text")
  }, minValueText), maxValueText && /*#__PURE__*/_react["default"].createElement("span", {
    "data-test-id": "".concat(id, "-progress-bar-max-text")
  }, maxValueText)));
};

var _default = ProgressBar;
exports["default"] = _default;
//# sourceMappingURL=index.js.map